import React from "react";
import { Route } from "react-router-dom";

const Home = React.lazy(() => import("../containers/Home"));
const TemplateEditor = React.lazy(() => import("../containers/TemplateEditor"));
const EHFTemplateEditor = React.lazy(
  () => import("../containers/EHFTemplateEditor")
);
const MainSearch = React.lazy(() => import("../containers/MainSearch"));
const DeliveryStatusDashboard = React.lazy(
  () => import("../containers/DeliveryStatusDashboard")
);

export default () => {
  return [
    <Route key="home" path={"/"} element={<Home />} />,
    <Route key="search" path={"/search"} element={<MainSearch />} />,
    <Route
      key="template-editor"
      path={"/template-editor"}
      element={<TemplateEditor />}
    />,
    <Route
      key="ehf-template-editor"
      path={"/ehf-template-editor"}
      element={<EHFTemplateEditor />}
    />,
    <Route
      key="usc-delivery-dashboard"
      path={"/usc-delivery-dashboard"}
      element={<DeliveryStatusDashboard />}
    />,
  ];
};
